module.exports = __webpack_public_path__ + "img/NIS.d72b2ad0.svg";